import React, { Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { DialogAppTitle, DialogAppContent, DialogAppActions } from 'components/DialogApp';

import ButtonLoader from 'components/common/ButtonLoader';

import { styles } from './AddTag.styles';
import Content from './Content';

const titleText = usersCount => {
  if (!usersCount) return 'No selected users';
  if (usersCount === 1) return 'Tag this person';
  return `Tag these ${usersCount} users`;
};

const tagButtonText = usersCount => {
  if (!usersCount) return null;
  if (usersCount === 1) return 'Tag this person';
  return `Tag these ${usersCount} users`;
};

const Layout = ({
  selectedUsers,
  toggleDialog,
  disableActionButton,
  handleAddTag,
  tags,
  actionValue,
  newTagValue,
  onChange,
  classes,
  existingTagValue,
}) => {
  const usersCount = selectedUsers.length;

  return (
    <Fragment>
      <DialogAppTitle small>
        {titleText(usersCount)}
      </DialogAppTitle>

      <DialogAppContent>
        {!!usersCount
          ? (
            <Content
              tags={tags}
              actionValue={actionValue}
              existingTagValue={existingTagValue}
              newTagValue={newTagValue}
              onChange={onChange}
              classes={classes}
            />
          )
          : <div>Select at least one user to be able to add a tag.</div>
        }

      </DialogAppContent>

      <DialogAppActions>
        <Button onClick={toggleDialog} color="primary">
          Cancel
        </Button>

        {!!usersCount && (
          <Button
            onClick={handleAddTag}
            color="primary"
            disabled={disableActionButton}
            autoFocus
          >
            {tagButtonText(usersCount)}
            {disableActionButton && <ButtonLoader />}
          </Button>
        )}
      </DialogAppActions>
    </Fragment>
  );
};

export default withStyles(styles)(Layout);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/AddTag/Layout.js